import React from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { DocumentDto } from 'api/Documents/Types/Document'
import { PermissionDto } from 'api/Identity/Types/PermissionDto'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { hasPermission } from 'utils/permissionsValidator'

interface ClientDetailsDocumentDetailedProps {
  dataItem: DocumentDto
  permissions: PermissionDto[]
  showDocumentPreviewModal({ id, name }: { id: string; name: string }): void
}

export const ClientDetailsDocumentDetailed: React.FC<ClientDetailsDocumentDetailedProps> = (
  props
) => {
  return (
    <React.Fragment>
      <Grid data={props.dataItem.relations || []} resizable>
        <Column
          title='Document'
          cell={(gridCellProps: GridCellProps) => {
            if (!hasPermission(props.permissions, PermissionsEnum.CanLinkDocument)) {
              return <td>{gridCellProps.dataItem.document.name}</td>
            }
            return (
              <td style={{ color: 'var(--link)', textDecoration: 'underline', cursor: 'pointer' }}>
                <span
                  onClick={() => props.showDocumentPreviewModal(gridCellProps.dataItem.document)}
                >
                  {gridCellProps.dataItem.document.name}
                </span>
              </td>
            )
          }}
        />
        <Column title='Type' field='type.name' />
      </Grid>
    </React.Fragment>
  )
}
